/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

export const Basnie29: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>('12 najpiękniejszych baśni');
  const [text2, setText2] = useState<string>('dla Adasia Kowalskiego');
  const [text3, setText3] = useState<string>("od Mamy Chrzestnej Anny");
  const [text4, setText4] = useState<string>("21.12.2021 r.");
  const [text5, setText5] = useState<string>("Z okazji pierwszych urodzin");
  const [text6, setText6] = useState<string>("od babci Asi i dziadka Andrzeja");
  const [text7, setText7] = useState<string>("48 cm radości");
  const [text8, setText8] = useState<string>("2021");
  const text1BasicSize = 74;
  const text2BasicSize = 54;
  const text3BasicSize = 36;
  const text4BasicSize = 36;
  const text5BasicSize = 34;
  const text6BasicSize = 34;
  const text7BasicSize = 34;
  const text8BasicSize = 34;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 850; // Maximum width for text
  const maxWidth2 = 550;
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'JustSayinDJBSandShoesandaFezBold'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'JustSayinDJBSandShoesandaFezBold'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'JustSayinDJBSandShoesandaFezBold'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  const adjustFontSize2 = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'JustSayinDJBSandShoesandaFezBold'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth2 && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'JustSayinDJBSandShoesandaFezBold'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth2 * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'JustSayinDJBSandShoesandaFezBold'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(
    () => setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 12)),
    [text1],
  );
  useEffect(
    () => setFontSizeText2(adjustFontSize2(text2, fontSizeText2, text2BasicSize, 12)),
    [text2],
  );
  useEffect(
    () => setFontSizeText3(adjustFontSize2(text3, fontSizeText3, text3BasicSize, 12)),
    [text3],
  );
  useEffect(
    () => setFontSizeText4(adjustFontSize2(text4, fontSizeText4, text4BasicSize, 12)),
    [text4],
  );
  useEffect(
    () => setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 12)),
    [text5],
  );
  useEffect(
    () => setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 12)),
    [text6],
  );
  useEffect(
    () => setFontSizeText7(adjustFontSize(text7, fontSizeText7, text7BasicSize, 12)),
    [text7],
  );
  useEffect(
    () => setFontSizeText8(adjustFontSize(text8, fontSizeText8, text8BasicSize, 12)),
    [text8],
  );


  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      false
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        {/* <ImageUploader
          onImageChange={(image) => setImage(image)}
          setStep={setStep}
        />
        {step === "crop" && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )} */}
        {/* <div style={{}}> */}
          {step !== "crop" && (
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? "Zapisywanie..." : "Zapisz"}
            </Button>
          )}
          {step === "crop" && (
            <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
          )}
        {/* </div> */}
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "JustSayinDJBSandShoesandaFezBold, Cardo-Regular, SpicyRice",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            lineHeight: `${fontSizeText1}px`,
            fontFamily: "SpicyRice",
            zIndex: "12",
            color: "#448dca",
            position: "absolute",
            top: "66px",
            left: "0px",
            right: "0px",
            margin: "auto",
            textAlign: "center",
            // letterSpacing: "0.2rem"
          }}
        />
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: "JustSayinDJBSandShoesandaFezBold",
            lineHeight: `${fontSizeText2}px`,
            position: "absolute",
            top: "190px",
            left: "0px",
            right: "60px",
            margin: "auto",
            textAlign: "right",
            transform: "rotate(0deg)",
            fontWeight: "400",
            color: "#979b2f",
            zIndex: "12",
            padding: "0px"
          }}
        />
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: "Cardo-Regular",
            lineHeight: `${fontSizeText3}px`,
            position: "absolute",
            top: "320px",
            left: "0px",
            right: "60px",
            // maxWidth: "120px",
            textAlign: "right",
            transform: "rotate(0deg)",
            fontWeight: "600",
            color: "#2861aa",
            zIndex: "12",
          }}
        />
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: "Cardo-Regular",
            lineHeight: `${fontSizeText4}px`,
            position: "absolute",
            top: "370px",
            left: "0px",
            right: "60px",
            // maxWidth: "120px",
            textAlign: "right",
            transform: "rotate(0deg)",
            fontWeight: "600",
            zIndex: "99",
            color: "#2861aa",
          }}
        />
        {/* <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: "JustSayinDJBSandShoesandaFezBold",
            lineHeight: `${fontSizeText5}px`,
            position: "absolute",
            bottom: "95px",
            left: "0px",
            right: "0px",
            // maxWidth: "100px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#2861aa"
          }}
        />
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: "JustSayinDJBSandShoesandaFezBold",
            lineHeight: `${fontSizeText6}px`,
            position: "absolute",
            bottom: "50px",
            left: "0px",
            right: "0px",
            // maxWidth: "120px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#2861aa"
          }}
        /> */}
        {/* <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: "JustSayinDJBSandShoesandaFezBold",
            lineHeight: `${fontSizeText7}px`,
            position: "absolute",
            bottom: "35px",
            left: "0px",
            right: "0px",
            // maxWidth: "90px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "#ecaf74"
          }}
        /> */}
        
        {/* <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: "JustSayinDJBSandShoesandaFezBold",
            lineHeight: `${fontSizeText8}px`,
            position: "absolute",
            top: "505px",
            left: "108px",
            maxWidth: "90px",
            textAlign: "center",
            transform: "rotate(0deg)",
            fontWeight: "400",
            zIndex: "99",
            color: "white"
          }}
        /> */}
        {/* Step: Crop */}
        {/* {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={121 / 118}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
            style={{
              top: "82mm",
              left: "50.5%",
              height: "121.5mm",
              width: "118.5mm",
              transform: "translateX(-50%)",
              borderRadius: "42% 40% 39% 54%",
            }}
          />
        )} */}

        {/* Step: View */}
        {/* {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            style={{
              position: "absolute",
              top: "82mm",
              left: "50.5%",
              height: "118.5mm",
              width: "120.5mm",
              transform: "translateX(-50%)",
              borderRadius: "42% 40% 39% 54%",
              zIndex: 6,
            }}
          />
        )}
        
        <img
          src="/images/Basnie10overlay.svg"
          style={{
            position: "absolute",
            zIndex: croppedImage && step === "view" ? 8 : 5,
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%'
          }}
        />
 */}

        <img
          src="/images/Basnie29.svg"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};